/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex:1 1 auto;flex:1 1 auto}"];
export { styles as styles };
